import { Form, Input, Modal, Select, useSelect } from "@pankod/refine-antd";
import { useGetIdentity, useList } from "@pankod/refine-core";
import { IBase, IState, IStateTransitionComments, IUser, stateAssignedTo } from "interfaces";
import { DATAPROVIDER_DEFAULT, DATAPROVIDER_LOOKUP, FETCH_ACTION, RESOURCE_PATH } from "scripts/site";

export declare type modalFormProps = {
  visible: boolean,
  modalTitle: string;
  onCancel: () => void;
  onSave: (values: IStateTransitionComments) => void;
  stateAction: string;
  entityType: string;
  entityId: string;
  currentState?: IState;
  fetchAssignedToList: boolean;
};

export const RenderCommentsModal: React.FC<modalFormProps> = ({
  visible,
  modalTitle,
  onCancel,
  onSave,
  stateAction,
  entityType,
  entityId,
  currentState,
  fetchAssignedToList
}) => {
  const [form] = Form.useForm();
  const { data: userData } = useGetIdentity();
  const record = userData as IUser;

  const { data, isLoading } = useList<stateAssignedTo>({
    dataProviderName: DATAPROVIDER_DEFAULT,
    resource: `${entityType}/${entityId}/${FETCH_ACTION}`,
    config: {
      filters: [
        {
          field: "operation",
          operator: "eq",
          value: "assignedToList"
        }
      ]
    },
    queryOptions: {
      enabled: fetchAssignedToList
    }
  });

  const probableState = currentState?.nextStates.find(st => st.action === stateAction);
  const computeAction = probableState?.computeAssignedToOnAction ? true : false;
  var assignedToList = data ? data.data.find(st => st.state === probableState?.stateId)?.assignedToList : [];

  const { selectProps: allUsersProps } = useSelect<IBase>({
    dataProviderName: DATAPROVIDER_LOOKUP,
    resource: RESOURCE_PATH.PROFILE,
    optionLabel: "nameEmail",
    optionValue: "id",
    filters: [{
      field: "id",
      operator: "ne",
      value: record?.id
    }],
    sort: [
      {
        field: "lastAccessedAt",
        order: "desc"
      }],
    queryOptions: {
      enabled: visible
    }
  });

  return (
    <Modal
      visible={visible}
      title={modalTitle}
      maskClosable={true}
      closable={true}
      okText={probableState?.buttonText}
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            onSave(values);
          });
      }}
    >
      <Form autoComplete="off"
        form={form}
        layout="vertical"
        initialValues={isLoading ? {} : { assignedTo: assignedToList, computeOnAction: computeAction }}
      >
        <Form.Item
          name="comments"
          label="Comments"
          colon={true}
          rules={[{ required: true, message: 'Please provide comments!' }]}
        >
          <Input maxLength={75} />
        </Form.Item>
        <Form.Item
          name="assignedTo"
          label={probableState?.transitionText || "Assign workflow to"}
          hidden={!probableState?.showAssignedTo}
          tooltip={probableState?.transitionTooltipText || `As per rule configuration, the ${entityType} will be assigned to below user(s), please update if you wish to assign to other available users.`}
          rules={[
            {
              required: probableState?.showAssignedTo,
              whitespace: true,
              type: "array",
              max: probableState?.multipleAssignedTo ? 5 : 1
            }
          ]}
        >
          <Select placeholder="Search Name or Email" listHeight={216} loading={isLoading}
            mode="multiple"
            disabled={!probableState?.showAssignedTo}
            {...allUsersProps}
            allowClear
            style={{position: 'relative'}}
          />
        </Form.Item>
        <Form.Item
          name="computeOnAction"
          hidden={true}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};